module.exports = __webpack_public_path__ + "static/media/18 Chin Strap.01206749.jpg";